import clsx from 'clsx';
import React, { FC } from 'react';

export interface LabelProps {
  text: string;
  darkBg?: boolean;
  customClassName?: string;
}

const Label: FC<LabelProps> = (props: LabelProps): JSX.Element => {
  const { text, darkBg = false, customClassName } = props;

  const className = {
    label: clsx(
      `${customClassName} font-regular font-weight-normal inline-flex items-center px-20px py-[6px] rounded-circle text-p2 md:py-[4px]`,
      'border-1px border-lightPurple monochrome:border-black',
      darkBg ? 'text-white' : 'text-purple80 monochrome:text-black'
    ),
  };
  const { label } = className;

  return <span className={label}>{text}</span>;
};

export default Label;
